import { z } from 'zod';

export const productRestrictionsSchema = z.object({
  projectLimit: z.number().nullish(),
  pageLimit: z.number().nullish(),
  teamEnabled: z.boolean(),
  maximumPublicAccessLevel: z.number(),
  figmaExportEnabled: z.boolean(),
  webflowExportEnabled: z.boolean(),
  commentsEnabled: z.boolean().default(true),
});

export type ProductRestrictions = z.infer<typeof productRestrictionsSchema>;
